import React from 'react';
import './App.css';
import './styles/theme.css';
import { AuthProvider } from './components/AuthContext';
import { ThemeProvider } from './components/ThemeContext';
import * as Realm from "realm-web";
import Navbar from './components/navbar';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Home from './components/pages/Home'
import Footer from './components/Footer';
import BetsHome from './components/pages/BetsHome';
import BetsHistory from './components/pages/BetsHistory';
import InvestmentsNew from './components/pages/InvestmentsNew';
import 'bootstrap/dist/css/bootstrap.min.css'
import AcquisitionsChart from './components/pages/Graphs';
import CreateBetForm from './components/pages/CreateBet';
import OpenBets from './components/pages/BetResults';
import Scores from './components/pages/Scores';
import Model from './components/pages/Model';
import Schedule from './components/pages/Schedule';
import Exchange from './components/pages/Exchange';
import TeamDetail from './components/pages/TeamDetail';
import Login from './components/pages/Login';
import MyAccount from './components/pages/MyAccount';
import Crowd from './components/pages/Crowd';
import Lab from './components/pages/Lab';
import Forum from './components/pages/Forum';
import SecuritiesDashboard from './components/pages/SecuritiesDashboard';
import { MobileProvider } from './components/MobileContext';
import PrivacyPolicy from './components/pages/PrivacyPolicy';
import Terms from './components/pages/Terms';

const app = new Realm.App({ id: "thebrainfund-qyrogsg" });

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <MobileProvider>
          <Router>
            <Navbar />
            <div className="main-content">
              <Switch>
                <Route path='/' exact component={Home} />
                <Route path='/bets_home' exact component={BetsHome} />
                <Route path='/investments' exact component={InvestmentsNew} />
                <Route path='/stats' exact component={AcquisitionsChart} />
                <Route path='/bets_history' exact component={BetsHistory} />
                <Route path='/create_bet' exact component={CreateBetForm} />
                <Route path='/open_bets' exact component={OpenBets} />
                <Route path='/scores' exact component={Scores} />
                <Route path='/schedule' exact component={Schedule} />         
                <Route path='/exchange' exact component={Exchange} /> 
                <Route path="/login" exact component={Login} /> 
                <Route path='/exchange/:team_symbol' exact component={TeamDetail} />
                <Route path='/myaccount' exact component={MyAccount} />
                <Route path='/crowd' exact component={Crowd} />
                <Route path='/lab' exact component={Lab} />
                <Route path='/forum' exact component={Forum} />
                <Route path="/tradingdash" component={SecuritiesDashboard} />
                <Route path="/privacy" exact component={PrivacyPolicy} />
                <Route path="/terms" exact component={Terms} />
              </Switch>          
            </div>
            <Footer/>
          </Router>
        </MobileProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}


export default App;
